export default "<script src=\"/front_mo/src/js/vendor.js\"></script>\r\n<script src=\"/front_mo/src/js/main.js\"></script>"